// libraries.
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

// slices.
import { apiInventoryPortal } from "../../apiSlices";

// interfaces.
import { ModelError } from "../../interfaces/interfaces";
import { AddBonusInfoData } from "../interfaces/interfaces";

// interfaces.
interface AddBonusInfoResponse {
  message: string;
  success: boolean;
}

export const addBonusInfo = apiInventoryPortal.injectEndpoints({
  endpoints: (builder) => ({
    addBonusInfo: builder.mutation({
      query: (addBonusInfoData: AddBonusInfoData) => ({
        body: addBonusInfoData,
        method: "POST",
        url: "/bonus_info",
      }),
      invalidatesTags: ["BonusInfo"],
      transformErrorResponse: (error: FetchBaseQueryError): ModelError => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: "addBonusInfo",
        };
        return modelError;
      },

      transformResponse: (response: AddBonusInfoResponse) => {
        return response;
      },
    }),
  }),
});

export const { useAddBonusInfoMutation } = addBonusInfo;
